import React, { useState, useEffect, Suspense } from "react";

import FilterOptions from "../FilterOptions/FilterOptions";

import "@rankmi/rankmi-table/dist/index.css";
import "./SelectionProcessIndex.scss";
import CardInfo from "../CardInfo/CardInfo";
import NewCardInfo from "../CardInfo/NewCardInfo";
import { EnterpriseAreaService } from "../../../src/core/services/enterprise_area_service";
import { SelectionProcessesService } from "../../../src/core/services/selection_processes_service";

import { Col, ConfigProvider, Pagination, Row, Skeleton } from "antd";
import esES from "antd/lib/locale/es_ES";

import { handleTypes } from "../../../src/utilities/filter_ransack";
import { openNotificationWithIcon } from "../../../src/utilities/notificationWithIcon";
import { createInitialState, metadata } from "../settings/initialStates";
import { RequestModal } from "@rankmi/workflows-app";
import {
  ATSWrapper,
  BulkImportsModal,
} from "@rankmi/ats-app";
import tableUtilities from "../../../src/utilities/table_utilities";
import { ClosingReasonService } from "../../../src/core/services/closing_reason_service";
import { FormViewer } from "@rankmi/all-in-one-components/lib/FormViewer";
import { SELECTION_PROCESSES_STATUSES_ARRAY } from "@frontend/constants/initialValues";
import { FormEmployeeRegistration } from "@rankmi/all-in-one-components/lib/FormEmployeeRegistration";
import { RegisterEmployeesForm } from "@rankmi/all-in-one-components/lib/RegisterEmployees";
import { FormOptionalSection } from "@rankmi/rankmi-optionals";
import { workflowApi } from "../../../src/configs/axios.config";

const initialFilters = {
  pages: {},
  pagination: metadata,
  search: {
    params: null,
    pages: null,
    pagination: metadata,
  },
};

const PersonnelRegistrationFormViewer = ({
  type,
  dispatchUpdate,
  showApproveButton,
  showCloseButton,
  showRejectButton,
  showDerivateButton,
  showSubmitButton,
  onCancel,
  onSubmit,
  onReject,
  onDeriveChanges,
  disabled,
  entry,
  structure,
  optionalComponent
}) => {
  return (
    <FormEmployeeRegistration
      showApproveButton={showApproveButton}
      showCloseButton={showCloseButton}
      showDerivateButton={showDerivateButton}
      showRejectButton={showRejectButton}
      showSubmitButton={showSubmitButton}
      onCancel={onCancel}
      onSubmit={onSubmit}
      onReject={onReject}
      onDeriveChanges={onDeriveChanges}
      type={type}
      dispatchUpdate={dispatchUpdate}
      disabled={disabled}
      entry={entry}
      origin="ats"
      structure={structure}
      optionalComponent={optionalComponent}
    />
  )
}

/**
 * New component for RegisterEmployeesForm Viewer (Mexico)
 * @param {*} props 
 * @returns 
 */
const RegisterEmployeesFormViewer = (props) => {
  return (
    <RegisterEmployeesForm {...props} />
  )
}

const SELECTION_PROCESS_QUERY = "SELECTION_PROCESS_QUERY";
const SELECTION_PROCCESS_FILTERS = "SELECTION_PROCCESS_FILTERS";

const SelectionProcessIndex = ({
  statusActive,
  current_user,
  isBasicWithUserColumns,
  userRole,
  canCreate,
  isAdmin,
  titleAllProcess,
  enterprise
}) => {
  const storageFilters =
    JSON.parse(localStorage.getItem(SELECTION_PROCESS_QUERY)) ?? initialFilters;
  const storageGroupedFilters = JSON.parse(
    localStorage.getItem(SELECTION_PROCCESS_FILTERS)
  );

  const [enterpriseAreas, setEnterpriseAreas] = useState([]);
  const [statuses, setStatuses] = useState(SELECTION_PROCESSES_STATUSES_ARRAY);
  const [isCharging, setIsCharging] = useState(false);
  const [searching, setSearching] = useState(false);
  const [byIds, setByIds] = useState({});
  const [search, setSearch] = useState("");
  const [data, setData] = useState({
    pages: {},
    pagination: metadata,
    search: {
      params:
        storageFilters?.search?.params ??
        createInitialState(statusActive, isBasicWithUserColumns),
      pages: {},
      pagination: metadata,
    },
  });
  const [authors, setAuthors] = useState([]);
  const [openModalRequest, setOpenModalRequest] = useState(false);
  const [idWorkFlowSelected, setIdWorkFlowSelected] = useState(null);
  const [closingReasons, setClosingReasons] = useState([]);
  const [filterClosingReasons, setFilterClosingReasons] = useState([]);
  const [pendingProcesses, setPendingProcesses] = useState(null);
  const [activeItem, setActiveItem] = useState(
    storageGroupedFilters?.activeItem ?? statusActive.id
  );
  const [openBulkModal, setOpenBulkModal] = useState(false);
  const [openFilter, setOpenFilters] = useState(false);
  const [workflowConfigurations, setWorkflowConfigurations] = useState([]);
  const enterPriseAreaService = new EnterpriseAreaService();
  const selectionProcessService = new SelectionProcessesService();
  const closingReasonService = new ClosingReasonService();
  const {
    pages,
    pagination,
    search: { pages: searchedPages, params, pagination: searchedPagination },
  } = data;

  useEffect(() => {
    getAreas();
    getClosingReasons();
  }, []);

  useEffect(() => {
    if (authors.length < 1 && openFilter) getAuthors();
    if (workflowConfigurations.length === 0 && openFilter) fetchWorkflowConfigurations();
  }, [openFilter]);

  const getAuthors = () => {
    selectionProcessService.getAuthors((data) => {
      const dataMapped = data.map((author) => {
        return {
          label: author.full_name,
          value: author.id,
        };
      });
      setAuthors(dataMapped);
    });
  };

  const getAreas = () => {
    enterPriseAreaService.getAll(
      (data) => {
        const areasMapped = data
          .map((area) => {
            return {
              id: area.id,
              name: area.name,
              parentId: area.parent_enterprise_area_id
            };
          })
          .sort(tableUtilities.sortAreas);
        setEnterpriseAreas(areasMapped);
      },
      (err) => console.error(err)
    );
  };

  const getClosingReasons = () => {
    closingReasonService.getAll(
      (data) => {
        const reasonsMapped = data.map((reason) => {
          return {
            label: reason.description,
            value: reason.id,
          };
        });
        setClosingReasons(data);
        setFilterClosingReasons(reasonsMapped);
      },
      (err) => { }
    );
  };

  async function handleFetchData(page, items, filters) {
    return await selectionProcessService.getCurrents(page, items, filters);
  }

  // Add this new utility function to handle params transformation
  const transformQueryParams = (params, statusIdOverride = null) => {
    // If we don't have params or no group structure, return empty params
    if (!params || !params.q || !params.q.g || params.q.g.length === 0) {
      return {
        q: {
          enterprise_area_id_in: params?.q?.enterprise_area_id_in,
          g: [],
          m: "and"
        }
      };
    }

    // Clone params to avoid modifying the original
    const newParams = {
      ...params,
      q: {
        ...params.q,
        g: JSON.parse(JSON.stringify(params.q.g)) // Deep clone groups
      }
    };

    // If we have a status override, apply it
    if (statusIdOverride !== null) {
      // Create status filter
      const statusFilter = {
        m: "and",
        selection_process_status_id_eq: statusIdOverride
      };

      try {
        // Get the filters from the first group
        const gFilters = newParams.q.g[0].g || [];
        
        // Find and remove any existing status filter
        const filteredG = gFilters.filter(item => 
          !item || !item.selection_process_status_id_eq
        );
        
        // Add our new status filter
        newParams.q.g[0].g = [...filteredG, statusFilter];
      } catch (err) {
        // If the structure is different, create a new structure
        newParams.q.g = [{
          m: "and",
          g: [statusFilter]
        }];
      }
    }

    return newParams;
  };

  // Utility to process special filters 
  const processSpecialFilters = (query) => {
    const firstGroup = query.g[0];
    const filtersGroup = firstGroup && firstGroup["g"] && firstGroup["g"][0];
    if (!firstGroup) return;
    
    // Handle special cases for certain filter types
    if (firstGroup["responsible_full_name_cont_all"]) {
      firstGroup["responsible_full_name_cont_all"] = 
        firstGroup["responsible_full_name_cont_all"].split(" ");
    }
  
    // Move applicant filters to the main query level
    if (filtersGroup) {
      if (Object.keys(filtersGroup).includes("have_applicants_true")) {
        query["have_applicants"] = true;
        delete filtersGroup["have_applicants_true"];
      }
      
      if (Object.keys(filtersGroup).includes("have_list_applicants_true")) {
        query["have_list_applicants_true"] = [filtersGroup["have_list_applicants_true"]];
        delete filtersGroup["have_list_applicants_true"];
      }
      
      if (Object.keys(filtersGroup).includes("have_list_applicants_false")) {
        query["have_list_applicants_false"] = [filtersGroup["have_list_applicants_false"]];
        delete filtersGroup["have_list_applicants_false"];
      }
      
      if (Object.keys(filtersGroup).includes("have_list_applicants_false_all")) {
        query["have_list_applicants_false"] = [filtersGroup["have_list_applicants_false_all"]];
        delete filtersGroup["have_list_applicants_false_all"];
      }
      
      if (Object.keys(filtersGroup).includes("have_list_applicants_true_all")) {
        query["have_list_applicants_true"] = [filtersGroup["have_list_applicants_true_all"]];
        delete filtersGroup["have_list_applicants_true_all"];
      }
    }
  };
  
  // Utility to build filter query
  const buildFilterQuery = (baseQuery, statusId, searchValue) => {
    const query = { ...baseQuery };
    
    // Initialize basic structure if it doesn't exist
    if (!query.g) {
      query.g = [{ m: "and" }];
    }
    
    // Process special filters (extract them to top level if needed)
    processSpecialFilters(query);
    // Get existing filters and remove any search or status filters
    const existingFilters = query.g[0].g || [];
    const filteredFilters = existingFilters.filter(filter => {
      // Remove search filters (workflow_id_or_id_eq_any or title_or_name_workflow_cont)
      const isSearchFilter = filter && (filter.workflow_id_or_id_eq_any !== undefined || 
                                       filter.title_or_name_workflow_cont !== undefined);
      // Remove status filters (selection_process_status_id_eq)
      const isStatusFilter = filter && filter.selection_process_status_id_eq !== undefined;
      
      return !isSearchFilter && !isStatusFilter;
    });
    
    // Start with filtered filters (without previous search/status filters)
    const filters = [...filteredFilters];
    
    // Add search filter if it exists
    if (searchValue !== undefined || searchValue !== null) {
      filters.push({
        m: "or",
        workflow_id_or_id_eq_any: searchValue,
        title_or_name_workflow_cont: searchValue,
      });
    }
    
    // Add status filter if not "all"
    if (statusId !== 0) {
      filters.push({
        m: "and",
        selection_process_status_id_eq: statusId,
      });
    }
    
    // Only add the filters if they exist
    if (filters.length > 0) {
      query.g[0].g = filters;
    }
    
    return query;
  };

  // Refactored fetch functions
  
  // Refactored to use the new utility
  const fetchHandleLoad = async (current, params) => {
    setIsCharging(true);
    try {
      const resultData = await handleFetchData(current, 10, params);
      setIsCharging(false);
      setSearching(false);
      setByIds(resultData.data);
      setData((prevState) => ({
        ...prevState,
        pages: {
          ...prevState.pages,
          [resultData.meta.currentPage]: resultData.data.map(({ id }) => id),
        },
        pagination: resultData.meta,
      }));
      return resultData;
    } catch (error) {
      setIsCharging(false);
      console.error("Error fetching data:", error);
      return null;
    }
  };

  // Refactored to use the new utility
  const fetchPendingSelectionProcesses = async (params) => {
    if (!params) return;
    
    try {
      // Transform params to show only status 8 (pending)
      const pendingParams = transformQueryParams(params, 8);
      
      // Fetch with limited page size since we only need count
      const resultData = await handleFetchData(1, 2, pendingParams);
      setPendingProcesses(resultData.meta.totalCount);
      return resultData.meta.totalCount;
    } catch (error) {
      console.error("Error fetching pending processes:", error);
      return 0;
    }
  };
  
  const fetchSelectionProcesses = async (current) => {
    try {
      const resultData = await handleFetchData(current, 10, params);
      setIsCharging(false);
      setByIds(resultData.data);
      if (resultData.data.length === 0) setSearching(false);
      setData((prevState) => ({
        ...prevState,
        search: {
          params: params,
          pages: {
            ...prevState.search.pages,
            [resultData.meta.currentPage]: resultData.data.map(({ id }) => id),
          },
          pagination: resultData.meta,
        },
      }));
      return resultData;
    } catch (error) {
      setIsCharging(false);
      console.error("Error fetching selection processes:", error);
      return null;
    }
  };
  
  // Simple wrapper to maintain backward compatibility
  const handleDataLoad = (current, params) => {
    return fetchHandleLoad(current, params);
  };

  const handleSearchDataLoad = (current) => {
    if (Object.keys(searchedPages).includes(current.toString())) {
      setSearching(true);
      setData((prevState) => ({
        ...prevState,
        search: {
          ...prevState.search,
          pagination: tableUtilities.generatePaginateMetadata(
            prevState.search.pagination,
            current
          ),
        },
      }));
    }
    
    return fetchSelectionProcesses(current);
  };

  const handleChangeFilters = (values) => {
    let q = {};
    let toDelete = [];
    let activeItem = values.activeItem ?? statusActive.id;
    setIsCharging(true);
    
    // Keep area filters if they exist
    if (params["q"] && params["q"]["enterprise_area_id_in"] !== undefined) {
      q["enterprise_area_id_in"] = params["q"]["enterprise_area_id_in"];
    }

    // Keep title or author search if it exists
    if (
      params["q"] &&
      params["q"]["title_or_author_name_or_author_last_name_cont"] !== undefined
    ) {
      q["title_or_author_name_or_author_last_name_cont"] =
        params["q"]["title_or_author_name_or_author_last_name_cont"];
    }

    // Set up the basic structure
    q["m"] = "and";
    q["general_condition"] = values.generalCondition;
    q["g"] = [{ m: "and" }];
    
    // Add user-defined filters
    if (values.data.length > 0) {
      const { generalCondition, data, groupedData } = values;
      
      handleTypes(
        values.filterType,
        q["g"][0],
        generalCondition,
        toDelete,
        data,
        groupedData
      );
    }
    
    // Build the complete filter query with search and status
    const finalQuery = buildFilterQuery(q, activeItem, search);

    const nextData = {
      ...data,
      pagination: {
        currentPage: 1,
      },
      search: {
        ...data.search,
        params: {
          ...data.search.params,
          q: finalQuery,
        },
      },
    };
    localStorage.setItem(SELECTION_PROCESS_QUERY, JSON.stringify(nextData));
    setData(nextData);

    const currentParams = {
      ...data.search.params,
      q: finalQuery,
    };
    
    // Use the refactored functions
    fetchHandleLoad(1, currentParams);
    fetchPendingSelectionProcesses(currentParams);
  };

  const handleSearch = (value) => {
    setSearch(value);
    setIsCharging(true);

    setData((prevState) => {
      // Build filter query preserving user-defined filters
      const currentQ = prevState.search.params.q || {};
      const newQ = buildFilterQuery(currentQ, activeItem, value);

      return {
        ...prevState,
        pagination: { currentPage: 1 },
        search: {
          ...prevState.search,
          pagination: { currentPage: 1 },
          params: {
            ...prevState.search.params,
            q: newQ,
          },
        },
      };
    });

    // Apply the same filter to load data
    const currentParams = {
      ...params,
      q: buildFilterQuery(params.q || {}, activeItem, value),
    };

    handleDataLoad(1, currentParams);
    fetchPendingSelectionProcesses(currentParams);
  };

  const handleChangeArea = (value) => {
    setIsCharging(true);
    
    // Actualizar el estado con el nuevo filtro de área
    setData((prevState) => {
      // Obtener los parámetros actuales
      const currentParams = { ...prevState.search.params };
      const currentQ = { ...currentParams.q || {} };
      
      // Actualizar el filtro de área
      const areaFilter = value.id > 0 ? value.successorHierarchy : undefined;
      
      // Construir la consulta final incorporando el filtro de área, manteniendo el estado activo y búsqueda
      const updatedQ = {
        ...currentQ,
        enterprise_area_id_in: areaFilter
      };
      
      // Aplicar buildFilterQuery para procesar correctamente todos los filtros
      const finalQuery = buildFilterQuery(updatedQ, activeItem, search);
      
      // Devolver el nuevo estado
      return {
        ...prevState,
        pagination: { currentPage: 1 },
        search: {
          ...prevState.search,
          pagination: { currentPage: 1 },
          params: {
            ...currentParams,
            q: finalQuery
          }
        }
      };
    });

    // Preparar los parámetros para las peticiones
    const currentParams = { ...params };
    const updatedQ = {
      ...currentParams.q || {},
      enterprise_area_id_in: value.id > 0 ? value.successorHierarchy : undefined
    };
    
    // Aplicar buildFilterQuery para procesar correctamente todos los filtros
    const finalQuery = buildFilterQuery(updatedQ, activeItem, search);
    
    // Realizar peticiones con los parámetros actualizados
    const updatedParams = {
      ...currentParams,
      q: finalQuery
    };
    
    // Cargar datos con los parámetros actualizados
    fetchHandleLoad(1, updatedParams);
    fetchPendingSelectionProcesses(updatedParams);
  };

  const onHandleSort = (value) => {
    setIsCharging(true);
    setData((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        params: {
          ...prevState.search.params,
          order: value.key,
        },
      },
    }));

    handleDataLoad(pagination.currentPage, {
      ...params,
      order: value.key,
    });
  };

  const onImport = () => setOpenBulkModal(true);

  const onDownloadExcel = async () => {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 50000); // 50 segundos timeout
      
      const response = await fetch("/api/v1/selection_processes/search.xlsx", {
        method: "POST",
        headers: {
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify(params),
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      // Manejo específico de códigos de error HTTP
      if (!response.ok) {
        let errorMessage = "Error al descargar el archivo";
        let errorDetails = "";

        if (response.status !== 200) {
          errorMessage = "Error al descargar el archivo";
          errorDetails = response.statusText;
        }

        // Intentar obtener mensaje de error del servidor
        try {
          const errorBody = await response.text();
          if (errorBody) {
            console.error("Server error response:", errorBody);
            // Si el servidor devuelve JSON con mensaje específico
            try {
              const errorJson = JSON.parse(errorBody);
              if (errorJson.error || errorJson.message) {
                errorDetails = errorJson.error || errorJson.message;
              }
            } catch (parseError) {
              // Si no es JSON válido, usar el texto tal como viene
              errorDetails = errorBody.substring(0, 100); // Limitar longitud
            }
          }
        } catch (textError) {
          console.error("Error reading response body:", textError);
        }

        openNotificationWithIcon("error", errorMessage, errorDetails);
        console.error(`Excel download failed: ${response.status} ${response.statusText}`, {
          url: response.url,
          headers: response.headers,
          params
        });
        return;
      }

      const blob = await response.blob();
      
      // Crear y descargar el archivo
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const timestamp = new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19);
      const filename = `${timestamp}_selection_processes.xlsx`;
      
      link.href = url;
      link.setAttribute("download", filename);
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      
      // Limpiar recursos
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      openNotificationWithIcon("success", "Descarga exitosa", `Archivo: ${filename}`);

    } catch (error) {
      let errorMessage = "Error al descargar el archivo";
      let errorDetails = error.message;

      console.error("Excel download error:", {
        error,
        message: error.message,
        stack: error.stack,
        params
      });

      openNotificationWithIcon("error", errorMessage, errorDetails);
    }
  };

  const fetchWorkflowConfigurations = () => {
    selectionProcessService.fetchWorkflowConfigurations(
      (data) => {
        const wConfs = data.map((conf) => { return { label: conf.name, value: conf.id } });
        setWorkflowConfigurations(wConfs)
      },
      (err) => console.error(err)
    );
  };

  const handlePause = (idProcess) => {
    selectionProcessService.supend(
      idProcess,
      (data) => {
        openNotificationWithIcon(
          "success",
          "Proceso suspendido correctamente",
          ""
        );
        handleDataLoad(pagination.currentPage, params);
      },
      (err) => console.error(err)
    );
  };

  const handleActivate = (idProcess) => {
    selectionProcessService.activate(
      idProcess,
      (data) => {
        openNotificationWithIcon(
          "success",
          "El proceso ha sido activado. Revisa la vista de procesos activos",
          ""
        );
        handleDataLoad(pagination.currentPage, params);
      },
      (err) => {
        openNotificationWithIcon("warning", err.response.data.error, "");
      }
    );
  };

  const handleFinish = (e, form, idProcess) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      selectionProcessService.close(
        idProcess,
        values,
        (data) => {
          openNotificationWithIcon(
            "success",
            "Proceso cerrado correctamente",
            ""
          );
          handleDataLoad(pagination.currentPage, params);
        },
        (err) => console.error(err)
      );
    });
  };

  const handleRequestClick = (idWorkFlow) => {
    setIdWorkFlowSelected(idWorkFlow);
    setOpenModalRequest(true);
  };

  const handleDelete = (idProcess) => {
    selectionProcessService.delete(
      idProcess,
      (data) => {
        openNotificationWithIcon(
          "success",
          "Proceso eliminado correctamente",
          ""
        );
        handleDataLoad(pagination.currentPage, params);
      },
      (err) => console.error(err)
    );
  };

  const handleChangeResponsible = (e, form, idProcess) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      selectionProcessService.updateById(
        idProcess,
        { responsible_user_id: values.responsible_user_id },
        (data) => {
          openNotificationWithIcon(
            "success",
            "Responsable actualizado correctamente",
            ""
          );
          handleDataLoad(pagination.currentPage, params);
        }
      );
    });
  };

  const handlePaginateData = (current, params) => {
    handleDataLoad(current, params);
  };

  const dataToShow = searching
    ? searchedPages[searchedPagination.currentPage]
      ?.filter((id) => byIds.find((it) => it.id == id) !== undefined)
      .map((id) => byIds.find((it) => it.id == id)) || []
    : pages[pagination.currentPage]
      ?.filter((id) => byIds.find((it) => it.id == id) !== undefined)
      .map((id) => byIds.find((it) => it.id == id)) || [];

  const totalData = searching
    ? searchedPagination.totalCount
    : pagination.totalCount;

  const handleUpdateAsTemplate = (idProcess, value) => {
    selectionProcessService.updateById(
      idProcess,
      { is_template: value },
      () => {
        openNotificationWithIcon(
          "success",
          "Proceso actualizado correctamente",
          ""
        );
        handleDataLoad(pagination.currentPage, params);
      },
      (err) => console.error(err)
    );
  };

  const handleUpdateRequestType = (processId, updatedProcess) => {
    // Actualizar solo el proceso específico en el estado byIds
    setByIds((prevByIds) => {
      // Si byIds es un array
      if (Array.isArray(prevByIds)) {
        return prevByIds.map((process) =>
          process.id === processId
            ? { 
                ...process, 
                request_type_data: updatedProcess.request_type_data && updatedProcess.request_type_data.length > 0
                  ? updatedProcess.request_type_data.map(rt => ({
                      id: rt.id,
                      name: rt.name
                    }))
                  : null
              }
            : process
        );
      }
      // Si byIds es un objeto con los procesos indexados
      return {
        ...prevByIds,
        [processId]: {
          ...prevByIds[processId],
          request_type_data: updatedProcess.request_type_data && updatedProcess.request_type_data.length > 0
            ? updatedProcess.request_type_data.map(rt => ({
                id: rt.id,
                name: rt.name
              }))
            : null
        }
      };
    });
  };

  return (
    <ConfigProvider locale={esES}>
      <div className="selection-process-index">
        <ATSWrapper>
          <RequestModal
            id={idWorkFlowSelected}
            isOpen={openModalRequest}
            setIsOpen={setOpenModalRequest}
            registerRequisitionForm={FormViewer}
            registerPersonnelRegistrationForm={
              PersonnelRegistrationFormViewer
            }
            registerEmployeesForm={RegisterEmployeesFormViewer}
            formOptional={FormOptionalSection}
          />
        </ATSWrapper>
        <Suspense fallback="">
          <BulkImportsModal
            open={openBulkModal}
            onClose={() => setOpenBulkModal(false)}
            type="selectionProcesses"
          />
        </Suspense>
        <FilterOptions
          areas={enterpriseAreas}
          selectionProcessesSize={totalData}
          onChangeFilters={handleChangeFilters}
          handleSort={onHandleSort}
          handleImport={onImport}
          handleDownload={onDownloadExcel}
          onChangeArea={handleChangeArea}
          authors={authors}
          onSearch={handleSearch}
          statuses={statuses}
          openFilter={openFilter}
          setOpenFilters={setOpenFilters}
          statusActive={statusActive}
          isAdmin={isAdmin}
          isBasicWithUserColumns={isBasicWithUserColumns}
          userRole={userRole}
          pendingProcesses={pendingProcesses}
          closingReasons={filterClosingReasons}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
          canCreate={canCreate}
          titleAllProcess={titleAllProcess}
          workflowConfigurations={workflowConfigurations}
        />

        {isCharging && (
          <Skeleton
            title={false}
            active={true}
            paragraph={{
              rows: 9,
            }}
          />
        )}

        {!isCharging && dataToShow.length > 0 && (
          <>
            {dataToShow.map((selectionProcess, key) => {
              return (
                <React.Fragment key={key}>
                  <NewCardInfo
                    selectionProcess={selectionProcess}
                    onPauseProcess={handlePause}
                    onFinishProcess={handleFinish}
                    onActivateProcess={handleActivate}
                    onRequestClick={handleRequestClick}
                    onResponsibleClick={(e, form) =>
                      handleChangeResponsible(e, form, selectionProcess.id)
                    }
                    onDeleteClick={handleDelete}
                    onUpdateAsTemplate={handleUpdateAsTemplate}
                    onUpdateRequestType={handleUpdateRequestType}
                    isBasicWithUserColumns={isBasicWithUserColumns}
                    closingReasons={closingReasons}
                    canSeeMenu={selectionProcess?.permissions?.can_see_menu}
                    currentUser={current_user}
                    userRole={userRole}
                  />
                </React.Fragment>
              );
            })}
            <Row>
              <Col xs={24}>
                <Pagination
                  className="list-process-pagination"
                  defaultCurrent={
                    searching
                      ? searchedPagination.currentPage
                      : pagination.currentPage
                  }
                  current={
                    searching
                      ? searchedPagination.currentPage
                      : pagination.currentPage
                  }
                  total={
                    searching
                      ? searchedPagination.totalCount
                      : pagination.totalCount
                  }
                  onChange={(current) =>
                    searching
                      ? handleSearchDataLoad(current)
                      : handlePaginateData(current, params)
                  }
                  showSizeChanger={false}
                />
              </Col>
            </Row>
          </>
        )}

        {!isCharging && dataToShow.length === 0 && (
          <div className="empty-message">No se encontraron procesos.</div>
        )}
      </div>
    </ConfigProvider>
  );
};

export default SelectionProcessIndex;
